<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import TncList from "@/components/t&c/list.vue";
import { TncManagementService } from "../../services/tnc/tnc.service";
import { commonService } from "../../helpers/common.service";

export default {
  data() {
    return {
      title: "T&C Management",
      items: [
        {
          text: "T&C Management",
          href: "#",
        },
        {
          text: "T&C Management",
          active: true,
        }
      ],
      tncFilesList: [],
    };
  },

  components: {
    Layout,
    PageHeader,
    TncList
  },

  methods: {
    async updateTncData() {
      try {
        const response = await TncManagementService.getTnc();
        this.tncFilesList = response.data;
      } catch (error) {
        this.handleError(error);
      }
    },
    async uploadTnc(file) {
      // Check if file is PDF
      if (!file || file.type !== 'application/pdf') {
        commonService.handleError('Please upload a valid PDF file.');
      }

      try {
        await TncManagementService.uploadTnc(file);
        await this.updateTncData();
        commonService.swalPrompt(true, "T&C Successfully Uploaded!");
      } catch (error) {
        commonService.handleError(error);
      }
    },
    async updateTnc({ file, item }) {
      try {
        await TncManagementService.updateTnc(file, item.id);
        await this.updateTncData();
        commonService.swalPrompt(true, "T&C Successfully Updated!");
      } catch (error) {
        commonService.handleError(error);
      }
    },
    async getTnc() {
      try {
        const response = await TncManagementService.getTnc();
        this.tncFilesList = response.data;
      } catch (error) {
        commonService.handleError(error);
      }

    },
    async deleteTnc(item) {
      const confirm = await commonService.swalConfirm("Confirm Delete T&C", "Are you sure you want to delete T&C?");
      if (confirm) {
        try {
          await TncManagementService.deleteTnc(item.id);
          await this.updateTncData();
          commonService.swalPrompt(true, "T&C Successfully Deleted!");
        } catch (error) {
          commonService.handleError(error);
        }
      }
    },
    async previewTnc(item) {
      try {
        const response = await TncManagementService.previewTnc(item.id);
        this.openPreview(response.url);
      } catch (error) {
        commonService.handleError(error);
      }
    },

    openPreview(url) {
      window.open(url, '_blank');
    },
  },

  mounted() {
    this.getTnc();
  },

}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <TncList :tncFilesList="tncFilesList" @upload-tnc="uploadTnc" @update-tnc="updateTnc" @delete-tnc="deleteTnc"
      @preview-tnc="previewTnc" />
  </Layout>
</template>
